import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, MessagesApi } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface UseMessagesCountStore {
  loading: boolean;
  data: number | null;
  error?: string | null;
  getMessagesCount: (refreshToken: string) => Promise<BaseReturn<any>>;
  clear: () => void;
}

export const useMessagesCountStore = create<UseMessagesCountStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  getMessagesCount: async (refreshToken: string) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await MessagesApi.getMessagesCount(refreshToken);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
